import { flattenNestedSvg } from '@/utils'

import { FrameText } from './FrameText'
import { MockQr } from './MockQr'
import {
	DEFAULT_FRAME_FONT,
	FRAME_BLACK,
	FRAME_LIGHT_GREY,
	FRAME_MEDIUM_GREY,
	TRANSPARENT_COLOR,
} from './qrFramesConstants'
import { isNormalFrameMode, TQrFrameProps } from './qrFrameTypes'

export const Frame18 = (props: TQrFrameProps) => {
	const { previewMode } = props

	const qrMarkup = isNormalFrameMode(props) ? props.patternMarkup : undefined
	const frameColor = isNormalFrameMode(props) ? props.frameColor : FRAME_BLACK
	const textColor = isNormalFrameMode(props) ? props.textColor : 'white'
	const qrBackgroundColor = isNormalFrameMode(props)
		? props.patternBackgroundColor
		: FRAME_LIGHT_GREY
	const frameBackgroundColor = isNormalFrameMode(props)
		? props.frameBackgroundColor
		: TRANSPARENT_COLOR

	const getTextY = (fontSize: number) => {
		const boxTop = 68
		const boxHeight = 10
		const centerY = boxTop + boxHeight / 2
		return centerY + fontSize * 0.085
	}

	return (
		<svg viewBox="0 0 64 84" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="frame-background"
				fill={frameBackgroundColor}
				d="M6 15h51v52H6z"
			/>
			<path
				id="frame"
				d="M59.123 17.153c0-2.303-1.857-4.153-4.128-4.153H8.024c-2.29 0-4.129 1.869-4.129 4.153L2 75.847C2 78.15 3.858 80 6.129 80H56.87c2.292 0 4.13-1.869 4.13-4.153zm-52.788 0c0-.925.75-1.699 1.689-1.699h46.97a1.7 1.7 0 0 1 1.69 1.7v48.951H6.334z"
				fill={frameColor}
			/>
			<g id="handle" fill={frameColor}>
				<path id="handle" d="m22.81 3.02-4.69 4.663v9.93h4.69z" />
				<path id="handle" d="m40.188 3.02 4.692 4.663v9.93h-4.692z" />
				<path
					id="shadow"
					d="M40.188 3H22.81v4.72h17.377z"
					fill={previewMode ? FRAME_MEDIUM_GREY : frameColor}
					fillOpacity={previewMode ? 1 : 0.5}
				/>
			</g>
			<rect
				id="qr-background"
				x={10}
				y="19.5"
				width="43"
				height="43"
				rx="2"
				fill={qrBackgroundColor}
			/>

			{qrMarkup ? (
				<g
					dangerouslySetInnerHTML={{
						__html: flattenNestedSvg(qrMarkup, {
							x: 16.5,
							y: 26,
							width: 30,
							height: 30,
						}),
					}}
				/>
			) : (
				<MockQr x={16.5} y={26} width={30} height={30} />
			)}
			<FrameText
				text={props.text}
				fontSize={props.fontSize}
				textColor={textColor}
				textY={getTextY(props.fontSize)}
				fontFamily={DEFAULT_FRAME_FONT}
			/>
		</svg>
	)
}
